import { render } from "./StickyContainer.vue?vue&type=template&id=c97520c4"
import script from "./StickyContainer.vue?vue&type=script&lang=js"
export * from "./StickyContainer.vue?vue&type=script&lang=js"

import "./StickyContainer.vue?vue&type=style&index=0&id=c97520c4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__